import { useLocation } from 'react-router-dom';
import { useStorefront } from '@/context/StorefrontContext';
import { StorefrontContentPage } from './StorefrontContentPage';
import { StorefrontFormPage } from './StorefrontFormPage';
import { SailingSchedulePage } from './SailingSchedulePage';

export function StorefrontRuntimeRoutePage() {
  const location = useLocation();
  const { routes } = useStorefront();
  const route = routes.find((item) => item.routePath === location.pathname);

  if (!route) {
    return (
      <div className="max-w-4xl mx-auto px-4 py-16 text-center">
        <h1 className="text-3xl font-bold text-slate-900 mb-3">Page not found</h1>
        <p className="text-slate-500">No published storefront route matches this URL.</p>
      </div>
    );
  }

  if (route.routeType === 'form') {
    return <StorefrontFormPage />;
  }

  if (route.routeType === 'module' && route.targetKey === 'sailing-schedule') {
    return <SailingSchedulePage />;
  }

  return <StorefrontContentPage />;
}
